/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { Link } from "react-router-dom";
import Spinner from "../../components/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { fetchMediaItems, selectAllMedia, selectMediaError, selectMediaStatus } from "./mediaSlice";
import { Segment, Checkbox } from 'semantic-ui-react';
import { selectCurrentUserAdmin } from "../currentUser/currentUserSlice";
import { AddMediaForm } from "./AddMediaForm";
import { changeBrowserTabTitle } from "../browserTabTitle/browserTabTitleSlice";
import { changeTool } from "../footer/footerSlice";
import { changeEnvironment } from "../environment/environmentSlice";

const MediaUnitDisplay = ({ mediaUnit }) => {
    const isAdmin = useSelector(selectCurrentUserAdmin)
    if (!mediaUnit) {
        return <></>
    }
    return <div style={{ marginBottom: "8px" }}>
        <span><b>{mediaUnit.label}</b> - {mediaUnit.dateDisplay}</span>
        {mediaUnit.url && <p><a href={mediaUnit.url} target="_blank" rel="noreferrer" >{mediaUnit.title}</a></p>}
        {mediaUnit.iFrame && <div>
            <span>{mediaUnit.title}</span>
            <span><div dangerouslySetInnerHTML={{ __html: mediaUnit.iFrame }} /></span>
        </div>}
        {isAdmin && <p><Link to={`/media/${mediaUnit.id}`}>Edit {mediaUnit.label}</Link></p>}
    </div>
}

const typeOptions = [{ "text": "Article", "value": "article", "key": "article" },
{ "text": "Book mention", "value": "book-mention", "key": "book-mention" },
{ "text": "Presentation", "value": "presentation", "key": "presentation" },
{ "text": "Press Release", "value": "press-release", "key": "press-release" },
{ "text": "Video", "value": "video", "key": "video" },
{ "text": "Other", "value": "other", "key": "other" }];

const yearOptions = [{ "text": "2020", "value": "2020", "key": "2020" },
{ "text": "2021", "value": "2021", "key": "2021" },
{ "text": "2022", "value": "2022", "key": "2022" },
{ "text": "2023", "value": "2023", "key": "2023" },
{ "text": "2024", "value": "2024", "key": "2024" },
{ "text": "2025", "value": "2025", "key": "2025" }];

const CheckBoxList = ({ labelText, options, state, setState }) => {
    return <div>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
            <label style={{ marginRight: "8px" }}>{labelText}  </label>
            {options.map((item, index) => {
                let value = item.value;
                let checked = state.includes(value);
                return <Segment className="inlineCheckbox" key={index} compact
                    onClick={() => {
                        setState(prevState => {
                            let newState = JSON.parse(JSON.stringify(prevState));
                            const index = newState.indexOf(value);
                            if (index !== -1) {
                                newState.splice(index, 1);
                            } else {
                                newState.push(value);
                            }
                            return newState;
                        });
                    }}>
                    <Checkbox className={checked ? "inlineCheckboxChecked" : "inlineCheckboxUnChecked"}
                        label={item.text}
                        checked={checked}
                        style={{ color: state.includes(value) ? "#000000" : "#777777" }}
                    />
                </Segment>
            })}
        </div>
    </div>
}

const Media = () => {

    const dispatch = useDispatch();

    const mediaLibrary = useSelector(selectAllMedia);
    const mediaStatus = useSelector(selectMediaStatus);
    const mediaError = useSelector(selectMediaError);
    const isAdmin = useSelector(selectCurrentUserAdmin);

    useEffect(() => {
        dispatch(changeBrowserTabTitle("Computable Publishing"));
        dispatch(changeTool(""));
        dispatch(changeEnvironment("Computable Publishing"));
    }, []);

    useEffect(() => {
        if (mediaStatus === 'idle') {
            dispatch(fetchMediaItems());
        }
    }, [mediaStatus, dispatch]);

    const [filterMediaTypeSelectedState, setFilterMediaTypeSelectedState] = useState(["article", "book-mention", "presentation", "press-release", "video", "other"]);
    const [filterMediaYearSelectedState, setFilterMediaYearSelectedState] = useState(["2020", "2021", "2022", "2023", "2024", "2025"]);

    const [filteredLibraryState, setFilteredLibraryState] = useState(mediaLibrary);

    useEffect(() => {
        if (mediaLibrary.length && filterMediaTypeSelectedState.length && filterMediaYearSelectedState.length) {
            let filteredLibrary = JSON.parse(JSON.stringify(mediaLibrary))
                .filter((item) => (filterMediaYearSelectedState.includes(item?.year) &&
                    filterMediaTypeSelectedState.includes(item?.type)));
            setFilteredLibraryState(filteredLibrary);
        }
    }, [filterMediaTypeSelectedState, filterMediaYearSelectedState, mediaLibrary])

    return <>
        <div className="pageheader">
            <h1>Media and Presentations</h1>
        </div>
        {mediaStatus === 'loading' && <Spinner />}
        {mediaStatus === 'failed' && <div>{mediaError}</div>}
        {mediaStatus === 'succeeded' && <div className="pagecontent">
            <CheckBoxList labelText={"Filter by type:"} options={typeOptions} state={filterMediaTypeSelectedState} setState={setFilterMediaTypeSelectedState} />
            <div style={{ margin: "8px" }} />
            <CheckBoxList labelText={"Filter by year:"} options={yearOptions} state={filterMediaYearSelectedState} setState={setFilterMediaYearSelectedState} />
            <br />
            {filteredLibraryState.map((mediaUnit, unitIndex) => { return <MediaUnitDisplay mediaUnit={mediaUnit} key={unitIndex} /> })}
            {isAdmin && <AddMediaForm />}
        </div>}
    </>;
};

export { Media, MediaUnitDisplay };